import swal from 'sweetalert';

export function onInfo(title,message) {
    swal({
      title: title,
      text: message,
      icon: "info",
      button: "Ok",
    });
  }